type SingleQuestionWritingTestContext = {
  program?: string | null
  subject?: string | null
  itemCount?: number
}

// An EACT Writing practice test is a single essay prompt, so Previous/Next and
// Mark for Review have nothing to act on. ACT is deliberately not included.
// The itemCount guard keeps both tools for any Writing content that ever ships
// with more than one item.
const WRITING_PROGRAM = 'EACT'
const WRITING_SUBJECT = 'writing'

export const isSingleQuestionWritingTest = ({
  program,
  subject,
  itemCount = 0,
}: SingleQuestionWritingTestContext): boolean =>
  program?.toUpperCase() === WRITING_PROGRAM &&
  subject?.toLowerCase() === WRITING_SUBJECT &&
  itemCount === 1
